<template>
	<el-popover placement="bottom" trigger="click" width="1000" @show="openFun()">
		<div class="calender-main-div">
			<div style="width: 500px;">
				<div class="calender-header">
					<div style="flex: 1">
						<b>{{ $fomatTime(hoverDate || calendarDate) }}</b>
						<span style="font-size: 14px">
							{{ void (lunar = getLunarOnj(new Date(hoverDate))) }}
							( 农历{{ lunar.getMonthInChinese() }}月{{ lunar.getDayInChinese() }} )
						</span>
					</div>
					<div style="width:190px">
						<el-button-group>
							<el-button size="mini" @click="setCalendarDate(dateAdd(calendarDate,'m',-1))">上个月</el-button>
							<el-button size="mini" @click="setCalendarDate(new Date())">今日</el-button>
							<el-button size="mini" @click="setCalendarDate(dateAdd(calendarDate,'m',1))">下个月</el-button>
						</el-button-group>
					</div>
				</div>
				<el-calendar class="calender-div-202211181442" :first-day-of-week="7"
					v-model="calendarDate" ref="calendar">
					<!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
					<template slot="dateCell" slot-scope="{date, data}">
						<div slot="reference" @mouseenter="hoverDateMethod(date)" @click="checkTime(null,date)"
							:style="$fomatTime(new Date()) === ($fomatTime(date)) ? 'border: 1px solid #409EFF;' : ''"
							:class="'calender-day ' + (isCheckedTime(date) ? 'calender-checked-day' : '')">
							<el-badge value="new" :hidden="$fomatTime(maxTime) !== data.day"
								class="el-badge-20221128" type="primary">
								<span :style="'font-weight: bolder;' +
									(isWeekend(date) ? 'color: #F56C6C;' : '')">{{ $fomatTime(date, 'D') }}</span>
							</el-badge>

							{{ void (obj = getLunar(date)) }}
							<span class="holiday-tag" v-if="obj.isRest">休</span>

							<span class="work-tag" v-else-if="obj.isRest === false">班</span>

							<div style="font-size: 12px;color: #909399;" class="overflow-one-line">
							<span :style="obj.mark ? 'color:  #F56C6C' : ''">
								{{ obj.name }}
							</span>
							</div>
							<div v-if="holidays[$fomatTime(date)]" style="position: absolute;bottom: 0;left: 0;right: 0">
								<div
									v-for="(item,index) in holidays[$fomatTime(date)].filter((i,index) => $fomatTime(i.beginDate) === data.day && index < 3)"
									:key="index" class="slot-div" :style="'background-color:' + color[index] + ';'">
								</div>
							</div>
						</div>
					</template>
				</el-calendar>
			</div>
			<!--右侧当前选中日详细-->
			<div style="flex: 1;">

				<div class="day-info" v-if="holidays[hoverDate]">
					<!--					<div class="day-info-head">-->
					<!--						<span style="font-size: 24px;font-weight: bolder">{{ hoverDate }}</span>-->
					<!--					</div>-->
					<div class="day-info-body">
						<div v-for="(item,index) in holidays[hoverDate]" :key="index" style="margin-bottom: 8px;">
							<el-card class="card-div-202211221458">
								<div slot="header" class="clear-float">
									<div style="display: flex;font-weight: bolder;">
										<div style="flex: 1;">
											{{ item.holidayName }}
											<span v-if="item.holidayName && item.holidayNameCh"> / </span>
											{{ item.holidayNameCh }}
										</div>
										<div style="width: 160px;text-align: right">
											<span>
												<span v-if="$fomatTime(item.beginDate) === $fomatTime(item.endDate)">
													{{ $fomatTime(item.beginDate, 'YYYY/MM/DD') }}
												</span>
												<span v-else>
													{{ $fomatTime(item.beginDate, 'YYYY/MM/DD') }} - {{ $fomatTime(item.endDate, 'YYYY/MM/DD') }}
												</span>
											</span>
										</div>
									</div>
								</div>
								<div>
									<div class="desc-div">{{ item.description }}</div>
									<el-tooltip class="item" effect="dark" :content="getCountryObjByCity(country).cn"
										placement="top-start" v-for="(country,index1) in item.list" :key="index1">
										<span :class="'fi fi-' + getCountryObjByCity(country).icon"
											style="margin-right: 5px;border: 1px solid #E4E7ED"></span>
									</el-tooltip>
								</div>
							</el-card>
						</div>
					</div>

				</div>
			</div>
		</div>
		<span slot="reference" >
			<el-tooltip effect="light" content="点击打开日历" placement="top">
				<el-badge value="new" class="item" is-dot>
					<slot>
						<el-button  style="color: red" icon="el-icon-date"></el-button>
					</slot>
				</el-badge>
			</el-tooltip>
		</span>
	</el-popover>
</template>

<script>
import { api_list_holidayDate } from "@/components/api/holidayDate";
import { dateAdd, getRangeOfMonth, getWeekFirstDay, getWeekLastDay, isWeekend } from "@/components/common/utils/time";
import { getCountryObjByCity } from "@/components/config/countryCodeConfig";
import { groupArr } from "@/components/common/utils/util";
import { Solar, Lunar, HolidayUtil } from "lunar-javascript";
import buyVipDialogSub from "@/components/template/view/userInfo/vip/sub/buyVipDialogSub";

export default {
	name: "timeSelectCalendar",
	data() {
		return {
			calendarDate: new Date(),
			checkTimes: [],
			hoverTimes : null,
			holidays: {},
			hoverDate: null,
			color: ['#9254de', '#f759ab', '#52c41a']
		}
	},
	props : {
		date : {

		},
		maxTime : {
			type : Date
		}
	},
	computed : {

	},
	created() {

	},
	methods: {
		hoverDateMethod : function(date) {
			let hoverDate = new Date(date)
			this.$data.hoverDate =  this.$fomatTime(hoverDate)
			if (hoverDate){
				this.$data.hoverTimes = [getWeekFirstDay(new Date(this.$fomatTime(hoverDate))),getWeekLastDay(new Date(this.$fomatTime(hoverDate)))]
			}
		},
		setCalendarDate :function(date) {
			this.$data.hoverDate = this.$fomatTime(date)
			this.$data.hoverTimes = null
			this.$refs.calendar.pickDay(date);
		},
		clearTime : function() {
			this.$data.checkTimes = []
		},
		openFun: function() {
			if (Object.keys(this.$data.holidays).length > 0) {
				return
			}
			this.$data.calendarDate = new Date(this.date)
			this.$options.methods.checkTime(this,this.$data.calendarDate)
			this.$options.methods.loadHoliday(this)
		},
		getLunarOnj: function(date) {
			return Lunar.fromDate(date)
		},
		getLunar: function(date) {
			let obj = { mark: false }
			let h = HolidayUtil.getHoliday(date.getFullYear(), date.getMonth() + 1, date.getDate())
			obj.isRest = (h && !h.isWork())
			let solarHolidays = Solar.fromDate(date).getFestivals();
			let lunar = Lunar.fromDate(date)
			if (lunar.getJieQi()) {
				obj.name = lunar.getJieQi()
				obj.mark = true
			} else if (lunar.getFestivals().length > 0) {
				obj.name = lunar.getFestivals()[0]
				obj.mark = true
			} else if (solarHolidays.length > 0) {
				obj.name = solarHolidays[0]
				obj.mark = true
			} else {
				obj.name = lunar.getDayInChinese()
			}
			return obj
		},
		loadHoliday: function(this_) {
			this_ = this_ || this
			let range = getRangeOfMonth(this_.$data.calendarDate)
			this_.$data.holidays = {}
			api_list_holidayDate(range[0], range[1]).then(res => {
				for (let key in res.data) {
					let ob = groupArr(res.data[key], 'holidayName').map(i => {
						let obj = i.list[0]
						i = { ...i, ...obj };
						delete i.country
						i.list = i.list.map(i => i.country)
						return i;
					})
					this_.$set(this_.$data.holidays, key, ob)
				}
			}).catch(err => {
				console.error(err)
			})
		},
		isCheckedTime: function(date) {
			if (this.$data.checkTimes.length <= 0){
				return
			}
			let b1 = this.$data.checkTimes.length >= 2 && this.$data.checkTimes[0].getTime() <= date.getTime() && this.$data.checkTimes[1].getTime() >= date.getTime();
			let b2 = this.hoverTimes && this.hoverTimes[0].getTime() <= date.getTime() && this.hoverTimes[1].getTime() >= date.getTime();
			return b1 || b2
		},
		checkTime: function(this_,date) {
			this_ = this_ || this
			if (date.getTime() > this_.maxTime.getTime()){
				return
			}
			this_.$emit('change',new Date(date))
			this_.$set(this_.$data.checkTimes,0,getWeekFirstDay(new Date(this_.$fomatTime(date))))
			this_.$set(this_.$data.checkTimes,1,getWeekLastDay(new Date(this_.$fomatTime(date))))
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
		isWeekend: function(date) {
			return isWeekend(date)
		},
		dateAdd: function(date, interval, number) {
			return dateAdd(new Date(date), interval, number)
		}
	},
	watch: {
		date : {
			handler(newVal,oldVal) {
				this.$data.calendarDate = new Date(this.date)
				this.$options.methods.checkTime(this,this.$data.calendarDate)
			}
		},
		calendarDate: {
			handler(newVal,oldVal) {
				if (!newVal){
					return
				}
				if (oldVal.getMonth() !== newVal.getMonth()) {
					this.$options.methods.loadHoliday(this)
				}
			}
		}
	}
}
</script>

<style scoped>
.calender-main-div {
	display: flex;
}

.calender-header {
	display: flex;
	padding: 0 10px;
	font-size: 20px;
}

.calender-day {
	text-align: center;
	font-size: 16px;
	box-sizing: border-box;
	padding: 5px 0;
	height: 60px;
	position: relative;
}

.calender-checked-day {
	color: #409EFF;
	background-color: rgb(217, 236, 255);;
}

.holiday-tag {
	font-size: 10px;
	vertical-align: middle;
	margin-left: 1px;
	background-color: #67C23A;
	color: #FFFFFF;
	box-sizing: border-box;
	padding: 1px;
}

.work-tag {
	font-size: 10px;
	vertical-align: middle;
	margin-left: 1px;
	background-color: #F56C6C;
	color: #FFFFFF;
	box-sizing: border-box;
	padding: 1px;
}

.slot-div {
	height: 7px;
	border-radius: 50%;
	width: 7px;
	display: inline-block;
	margin: 0 1px;
}

.day-info {
	margin-top: 8px;
}

.day-info-head {
	border-bottom: 1px solid #E4E7ED;
	margin-bottom: 10px;
	padding-bottom: 10px;
}

.day-info-body {
	height: 440px;
	overflow-y: auto;
	padding-left: 10px;
	padding-right: 5px;
	border-left: 1px solid #DCDFE6;

}

.desc-div {
	margin-top: 10px;
	margin-bottom: 5px;
}
</style>
<style>
.calender-div-202211181442 .el-calendar__header {
	display: none;
}

.calender-div-202211181442 .el-calendar__body {
	padding-bottom: 12px;
	padding-left: 0;
	padding-right: 10px;
}


.calender-div-202211181442 th {
	text-align: center;
}

.calender-div-202211181442 .el-calendar-table td {
	border: 0 !important;
	vertical-align: middle;
}

.calender-div-202211181442 .el-calendar-table .el-calendar-day {
	height: auto !important;
	padding: 0 !important;
}

.calender-div-202211181442 .el-calendar-table:not(.is-range) td.next,
.el-calendar-table:not(.is-range) td.prev{
	color: unset;
	opacity: 0.4;
}
.el-badge-20221128 .el-badge__content{
	right: 0;
}
.card-div-202211221458 {
	box-shadow: unset !important;
	-webkit-box-shadow: unset !important;
}

.card-div-202211221458 .el-card__header {
	padding: 10px;
	background-color: rgba(235, 238, 245, 0.71);
}

.card-div-202211221458 > .el-card__body {
	padding: 5px 20px;
}
</style>